<template>
	<div class="incenters">
		<!-- style="border: 1px solid red;" v-if="qx.add"   v-if="qx.update"-->
		<div>
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增"
				fontSize="14px" @btnclick="addckd">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" :useAutoOptional="false" :optional="editops" opwidth="72px" top='219px'
				:src="require('@/assets/icon/icon-update.png')" title="修改" fontSize="14px" @btnclick="updateckd">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="审核" fontSize="14px" @btnclick="shen"
				:src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.revoke" title="弃审" fontSize="14px" @btnclick="qshen"
				:src="require('@/assets/icon/shua.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.changetv" backgroundColor="#FFF" title="整仓调拨" fontSize="14px" @btnclick="tb"
				:src="require('@/assets/icon/qis.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="TVExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad backgroundColor="#FFF" title="导入" fontSize="14px" @getFile="TransVouchImport"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
				@click="dowloadTemplet">下载调拨单导入模版</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="ChallengingRef" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=522 :tableData="tableData" :headerData="headerData" height="100%"></Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleshen" @cancel="cancelshen"
			@dialogOK="dialogOKshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核通过这条调拨单信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqshen" @cancel="cancelqshen"
			@dialogOK="dialogOKqshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要弃审通过这条调拨单信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条调拨单信息吗？</span>
		</Dialog>
		<DialogFrom width="1000px" title="客户变更调拨" :dialogVisible="dialogVisiblestb" @cancel="canceltb"
			@dialogOK="dialogOKtb">
			<div class="from">
				<div style="padding-bottom: 24px;">
					<template v-for="(item , index) of topFromdata">
						<Commondropdownlist ref="tbtopref" :event="item.event" :key="index" :options="item.options"
							:btx="item.btx" :inputdata="item.inputdata" @handleChange="handleChange" :title="item.title"
							:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
							:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
							:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
					</template>
				</div>
				<div class="titlefrom">
					原经销商信息
				</div>
				<template v-for="(item , index) of tbfromdata">
					<Commondropdownlist ref="tbyuref" :disabled="item.disabled" :loading="loading" :event="item.event"
						@remoteHosType="remoteHosType" @BaChage="BaChage" :key="index" :options="item.options"
						:btx="item.btx" :inputdata="item.inputdata" @handleChange="handleChange" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
						:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</template>
				<div
					style="width: 952px; height: 1px; background-color: #F0F0F0;margin-left: 0px;margin-top: 30px;margin-bottom: 30px;">
				</div>
				<div class="titlefrom">
					新经销商信息
				</div>
				<template v-for="(items , index) of tbnewfromdata">
					<Commondropdownlist ref="tbnewref" :disabled="items.disabled" :loading="loading"
						@remoteHosType="remoteHosType" :event="items.event" @BanewChage="BanewChage"
						:key="index+'tbnew'" :options="items.options" :btx="items.btx" :inputdata="items.inputdata"
						@handleChange="handleChange" :title="items.title" :fontSize="items.fontSize"
						:color="items.color" :radiotitle1="items.radiotitle1" :radiotitle2="items.radiotitle2"
						:lablewith="items.lablewith" :placeholder="items.placeholder" :types="items.types"
						:inputtype="items.inputtype" :width="items.width"></Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesqsjg" @cancel="cancelqsjg"
			@dialogOK="dialogOKqsjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDataqsjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom ref="dialogadd" :OKASCAN="false" width="1000px" title="新增调拨单"
			:dialogVisible="dialogVisibleoutboundorder" @cancel="canceloutboundorder"
			@dialogOK="dialogOKcanceloutboundorder">
			<div class="from">
				<div class="froms">
					<div style="border-bottom: 1px solid #f0f0f0; overflow-y: scroll;">
						<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="保存"
							fontSize="14px" @btnclick="addsave">
						</Commonbtn>
						<div v-if="Detailflag" style="display: inline-block">
							<CommonbtnUpLoad backgroundColor="#FFF" title="上传调拨单明细" fontSize="14px" @getFile="UnImport"
								:src="require('@/assets/icon/icon-drjys.png')">
							</CommonbtnUpLoad>
							<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
								@click="dowload">下载导入模版</a>
						</div>
						<div v-if="Uniqueflag" style="display: inline-block">
							<CommonbtnUpLoad backgroundColor="#FFF" title="上传调拨单唯一码明细" fontSize="14px"
								@getFile="UniqImport" :src="require('@/assets/icon/icon-drjys.png')">
							</CommonbtnUpLoad>
							<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
								@click="Uniqdowload">下载导入模版</a>
						</div>
					</div>

					<div class="inputtop"
						style="width: 960px !important;height: 160px;border-bottom: 1px solid #f0f0f0;background-color: #ffffff;padding-bottom: 70px;animation: shows 0.2s linear;overflow: hidden;"
						v-if="showorhide">
						<template v-for="(item , index) of addtb">
							<Commondropdownlist ref="tbadd" :disabled="item.disabled" :loading="loading"
								:event="item.event" @TBnewChage="TBnewChage" @TBChage="TBChage" @invClass="invClass"
								:btx="item.btx" :key="index" :options="item.options" :minrigth="item.minrigth"
								:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
								:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
								:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
								:types="item.types" :inputtype="item.inputtype" :width="item.width">
							</Commondropdownlist>
						</template>
					</div>
				</div>
				<div style="width: 970px;">
					<AddDialogFromTable @tabClick="tabClick" ref="AddDialog" :dialogindex="dialogindex"
						@handleSelectionChange="handleSelectionChangeAddDialogFromTable" @addclick="addclick"
						width="500px" colnum=7 :cusCodeStatus="cusCodeStatus" :dpmid="dpmid" :state="state"
						:tableData="tableDataMD" height="100%">
					</AddDialogFromTable>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom ref="dialogadd" width="1000px" :OKASCAN="false" title="修改调拨单"
			:dialogVisible="dialogVisibleoutboundorderedit" @cancel="canceloutboundorderedit"
			@dialogOK="dialogOKcanceloutboundorderedit">
			<div class="from">
				<div class="froms">
					<div style="border-bottom: 1px solid #f0f0f0;">
						<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="保存"
							fontSize="14px" @btnclick="editsave">
						</Commonbtn>
						<div v-if="Detailflag" style="display: inline-block">
							<CommonbtnUpLoad backgroundColor="#FFF" title="上传调拨单明细" fontSize="14px" @getFile="UnImport"
								:src="require('@/assets/icon/icon-drjys.png')">
							</CommonbtnUpLoad>
							<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
								@click="dowload">下载导入模版</a>
						</div>
						<div v-if="Uniqueflag" style="display: inline-block">
							<CommonbtnUpLoad backgroundColor="#FFF" title="上传调拨单唯一码明细" fontSize="14px"
								@getFile="UniqImport" :src="require('@/assets/icon/icon-drjys.png')">
							</CommonbtnUpLoad>
							<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
								@click="Uniqdowload">下载导入模版</a>
						</div>
					</div>

					<div class="inputtop"
						style="width: 960px !important;height: 160px;border-bottom: 1px solid #f0f0f0;background-color: #ffffff;padding-bottom: 70px;animation: shows 0.2s linear;overflow: hidden;"
						v-if="showorhide">
						<template v-for="(item , index) of updatetb">
							<Commondropdownlist ref="tbupdate" :disabled="item.disabled" :loading="loading"
								:event="item.event" @TBChageUp="TBChageUp" @TBnewChageUp="TBnewChageUp"
								@invClass="invClass" :btx="item.btx" :key="index" :options="item.options"
								:minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft"
								:maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata"
								:title="item.title" :fontSize="item.fontSize" :color="item.color"
								:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
								:width="item.width"></Commondropdownlist>
						</template>
					</div>
				</div>
				<AddDialogFromTable @tabClick="tabClick" ref="AddDialog" :dialogindex="dialogindex"
					@handleSelectionChange="handleSelectionChangeAddDialogFromTable" @addclick="addclick" width="500px"
					colnum=7 :dpmid="dpmid" :state="state" :tableData="tableDataMD" height="100%">
				</AddDialogFromTable>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import Dialog from '../../../../components/dialog.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import AddDialogFromTable from './addDialogFromTable.vue'
	import tb from '../fromData/tb'
	import newtb from '../fromData/newtb'
	import addtb from '../fromData/addtb'
	import updatetb from '../fromData/updatetb'
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import {
		TransVouchInfo,
		TransVouchDelete,
		TransVouchUnVerify,
		TransVouchVerify,
		BaOrganizationInfo,
		InventoryClassList,
		WarehouseList,
		TransVouchImport,
		TransVouchDownloadTemplet,
		TransVouchChangeCustomerByTV,
		InventoryClassInfo,
		TransVouchImportDetail,
		TransVouchImportUnique,
		TransVouchDownloadDetailTemplet,
		TransVouchDownloadUniqueTemplet,
		TransVouchAdd,
		TransVouchEdit,
		CustomerList
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			Dialog,
			DialogFrom,
			Commondropdownlist,
			CommonbtnUpLoad,
			AddDialogFromTable,
			CommonBtngroup
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			tableDataMD: {
				type: Array,
				default: Array
			},

		},
		data: function() {
			return {
				dialogVisibleshen: false,
				dialogVisibleqshen: false,
				dialogVisiblestb: false,
				dialogVisibledel: false,
				dialogVisiblesqsjg: false,
				dialogVisibleoutboundorder: false,
				loading: false,
				Detailflag: true,
				Uniqueflag: false,
				showorhide: true,
				loading: true,
				dialogVisibleoutboundorderedit: false,
				cusCodeStatus: "",
				tableDataqsjg: [],
				addtb: [],
				updatetb: [],
				WHNames: "",
				WHCodes: "",
				WHCode7: "",
				WHName7: "",
				WHCodeTb3: "",
				WHNameTb3: "",
				AddTableSelectiondetailList: [],
				title: "",
				dpmid: "",
			dialogindex: '',
			typetb: 0,
			editops: true,
			headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50,
					},
					{
						prop: 'StatusName',
						label: '状态',
						columnwidth: 100
					},
					{
						prop: 'TVCode',
						label: '调拨单号',
						columnwidth: 146
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 100
					},
					{
						prop: 'TVDate',
						label: '调拨日期',
						columnwidth: 102
					},
					{
						prop: 'OCusName',
						label: '调出方名称',
						columnwidth: 200
					},
					{
						prop: 'ICusName',
						label: '调入方名称',
						columnwidth: 200
					},
					{
						prop: 'OCusType',
						label: '调出方类型',
						columnwidth: 75
					},
					{
						prop: 'ICusType',
						label: '调入方类型',
						columnwidth: 75
					},
					{
						prop: 'TransVouchReason',
						label: '调拨原因',
						columnwidth: 100
					},
					{
						prop: 'Remark',
						label: '备注',
						columnwidth: 150
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 158
					},
					{
						prop: 'CreateTime',
						label: '创建时间',
						columnwidth: 130
					},
					{
						prop: 'VerifierName',
						label: '审核人',
						columnwidth: 108
					},
					{
						prop: 'VerifyTime',
						label: '审核时间',
						columnwidth: 130
					},
				],
				tbfromdata: [],
				tbnewfromdata: [],
				state: [{
					title: '明细'
				}, ],
				topFromdata: [{
					inputdata: "",
					title: "产品线",
					fontSize: "14px",
					color: "#333333",
					placeholder: "请选择",
					types: "",
					inputtype: "select",
					width: "210px",
					btx: true,
					options: [],
					lablewith: "80px",
				},
				{
					inputdata: "",
					title: "备注",
					fontSize: "14px",
					color: "#333333",
					placeholder: "请输入",
					types: "text",
					inputtype: "input",
					width: "210px",
				}, ],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changetv: false
				},
				tvmid: "",
				tvmidarr: [],
				tbyuflag: 0,
				tbyunewflag: 0,
				rowboo: false
			}
		},
		mounted() {
			this.tbfromdata = JSON.parse(JSON.stringify(tb))
			this.tbnewfromdata = JSON.parse(JSON.stringify(newtb))
			this.addtb = JSON.parse(JSON.stringify(addtb))
			this.updatetb = JSON.parse(JSON.stringify(updatetb))
			let data = JSON.parse(localStorage.getItem("MenusData"))
			let NodeID = this.$route.query.NodeID
			data.Menus.map((item, index) => {
				if (item.NodeID == 18) {
					item.Nodes.map((items, indexs) => {
						if (items.NodeID == 21) {
							this.qus = items.Nodes
						}
					})
				}
			})
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'skip') {
						this.qx.skip = true
					} else if (item.NodeName == 'reset') {
						this.qx.reset = true
					} else if (item.NodeName == 'revoke') {
						this.qx.revoke = true
					} else if (item.NodeName == 'changetv') {
						this.qx.changetv = true
					}
				})
			}
		},
		methods: {
			// 详情
			async TransVouchInfo() {
				let {
					code,
					data
				} = await TransVouchInfo({
					tvmid: this.tvmid
				})
				if (code == 0) {
					this.$refs.tbupdate[0].modelvalue = data.OCusName
					this.$refs.tbupdate[1].modelvalue = data.OCusCode
					this.$refs.tbupdate[2].modelvalue = data.OCusType
					this.$refs.tbupdate[3].modelvalue = data.OWhCode
					this.$refs.tbupdate[4].modelvalue = data.ICusName
					this.$refs.tbupdate[5].modelvalue = data.ICusCode
					this.$refs.tbupdate[6].modelvalue = data.ICusType
					this.$refs.tbupdate[7].modelvalue = data.IWhCode
					this.$refs.tbupdate[9].modelvalue = data.TransVouchReason
					this.$refs.tbupdate[8].modelvalue = data.InvClass
					this.$refs.tbupdate[10].modelvalue = data.Remark
					this.inventoryClassInfo(data.InvClass)
					let arr = []
					let objDet = {}
					data.DetailList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						objDet = Object.assign({}, item, {
							ids: num
						})
						arr.push(objDet)
					})
					let arrUin = []
					let objUin = {}
					data.DetailUniqueList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						objUin = Object.assign({}, item, {
							ids: num
						})
						arrUin.push(objUin)
					})
					this.$refs.AddDialog.tableDataDetailunNo = arr
					this.$refs.AddDialog.tableDataDetail = arr
					this.$refs.AddDialog.tableDataDetailUnique = arrUin
					let obj = {
						CusGrade: data.OCusType == "平台" ? 1 : 2,
						CusCode: data.OCusCode,
						type: 1
					}
					this.warehouseListInfo(obj)
					let obj1 = {
						CusGrade: data.ICusType == "平台" ? 1 : 2,
						CusCode: data.ICusCode,
						type: 2
					}
					this.warehouseListInfo(obj1)
				}
			},
			async remoteHosType(query) {
				this.loading = true
				let {
					data,
					code
				} = await CustomerList({
					CusName: query,

				})
				if (code == 0) {
					this.tbfromdata[0].options = []
					this.tbnewfromdata[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName
						}
						this.tbfromdata[0].options.push(obj)
						this.tbnewfromdata[0].options.push(obj)
					})
					this.loading = false
				}
			},
			async warehouseListInfo(parms) {
				let {
					code,
					data,
					message
				} = await WarehouseList({
					cusGrade: parms.CusGrade,
					cusCode: parms.CusCode
				})
				if (code == 0) {
					if (parms.type == 1) {
						this.updatetb[3].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.WHCode,
								value: item.WHName,
							}
							this.updatetb[3].options.push(obj)
						})
					}
					if (parms.type == 2) {
						this.updatetb[7].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.WHCode,
								value: item.WHName,
							}
							this.updatetb[7].options.push(obj)
						})
					}
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			// 点击行
			onRowClick(val) {
				if (this.tvmidarr && this.tvmidarr.length === 1) {
					this.rowboo = true
					this.tvmid = this.tvmidarr[0].TVMID
					this.editops = this.tvmidarr[0].Status == 0 ? false : true
				} else {
					this.editops = true
				}
				//console.log(val, 'val');
				this.$emit("onRowClick", val)
			},
			// 导出
			TVExport() {
				this.$emit('TVExport')
			},
			// 删除
			async transVouchDelete() {
				let arr = []
				this.tvmidarr.map((item, index) => {
					arr.push(item.TVMID)
				})
				let {
					code,
					message,
					data
				} = await TransVouchDelete({
					tvmiDs: arr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.tvmidarr = []
					this.$parent.transVouchList()
					this.$refs.ChallengingRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.title = "删除结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 审核
			async transVouchVerify(que = false) {
				let arr = []
				this.tvmidarr.map((item, index) => {
					arr.push(item.TVMID)
				})
				let params = {
					TVMIDs: arr
				}
				if (que) {
					params.NoNeedCheckInventoryProvince = 1;
				}
				let {
					code,
					message,
					data
				} = await TransVouchVerify(params)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '审核成功'
					});
					this.tvmidarr = [];
					this.$parent.transVouchList()
					this.$refs.ChallengingRef.$refs.fileTableSelect.setCurrentRow()
				} else if (code == 300) {
					this.$confirm(`<strong>${message}</strong><br/>${data.join(',<br/>')}`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true
					}).then(() => {
						this.transVouchVerify(true);
					}).catch(() => {});
				} else {
					this.title = "审核结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 弃审
			async transVouchUnVerify() {
				let arr = []
				this.tvmidarr.map((item, index) => {
					arr.push(item.TVMID)
				})
				let {
					code,
					message,
					data
				} = await TransVouchUnVerify({
					tvmiDs: arr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '弃审成功'
					});
					this.tvmidarr = []
					this.$parent.transVouchList()
					this.$refs.ChallengingRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.title = "弃审结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 仓库
			async warehouseList(parms) {
				let {
					code,
					data
				} = await WarehouseList({
					cusGrade: parms.CusGrade,
					cusCode: parms.CusCode
				})
				if (code == 0) {
					if (this.typetb == 1) {
						this.tbfromdata[3].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.WHCode,
								value: item.WHName
							}
							this.tbfromdata[3].options.push(obj)
						})
						this.tbfromdata[3].inputdata = this.tbfromdata[3].options[0].value
						this.WHCodeTb3 = this.tbfromdata[3].options[0].key
						this.WHNameTb3 = this.tbfromdata[3].options[0].value

					}
					if (this.typetb == 2) {
						this.tbnewfromdata[3].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.WHCode,
								value: item.WHName
							}
							this.tbnewfromdata[3].options.push(obj)
						})
						this.tbnewfromdata[3].inputdata = this.tbnewfromdata[3].options[0].value
						// this.tbnewfromdata[3].inputdata = this.tbnewfromdata[3].options[0].key
						// this.tbfromdata[3].inputdata = this.tbfromdata[3].options[0].key

					}
					if (this.typetb == 3) {
						this.addtb[7].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.WHCode,
								value: item.WHName
							}
							this.addtb[7].options.push(obj)
						})
						this.addtb[7].inputdata = this.addtb[7].options[0].value
						this.WHCode7 = this.addtb[7].options[0].key
						this.WHName7 = this.addtb[7].options[0].value

					}
					if (this.typetb == 4) {
						this.addtb[3].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.WHCode,
								value: item.WHName
							}
							this.addtb[3].options.push(obj)
						})
						this.addtb[3].inputdata = this.addtb[3].options[0].value
						this.WHNames = this.addtb[3].options[0].value
						this.WHCodes = this.addtb[3].options[0].key
					}
					if (this.typetb == 5) {
						this.updatetb[3].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.WHCode,
								value: item.WHName
							}
							this.updatetb[3].options.push(obj)
						})
						this.updatetb[3].inputdata = this.updatetb[3].options[0].key
					}
					if (this.typetb == 6) {
						this.updatetb[7].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.WHCode,
								value: item.WHName
							}
							this.updatetb[7].options.push(obj)
						})
						this.updatetb[7].inputdata = this.updatetb[7].options[0].key
					}
				}
			},
			// 经销商
			async baOrganizationInfo(companyName) {
				let {
					code,
					data,
					message
				} = await BaOrganizationInfo({
					companyName: companyName
				})
				if (code == 0) {
					console.log(this.typetb, 'this.typetb');
					if (this.typetb == 1) {
						this.$refs.tbyuref[0].modelvalue = data.CusName
						this.$refs.tbyuref[1].modelvalue = data.CusCode
						this.$refs.tbyuref[2].modelvalue = data.CusGradeName
						if (data.CusGrade == 1) {
							this.tbyuflag = 1
						}
						if (data.CusGrade == 2) {
							this.tbyuflag = 2
						}
						this.warehouseList(data)
					}
					if (this.typetb == 2) {
						this.$refs.tbyuref[0].modelvalue = data.CusName
						this.$refs.tbnewref[1].modelvalue = data.CusCode
						this.$refs.tbnewref[2].modelvalue = data.CusGradeName
						if (data.CusGrade == 1) {
							this.tbyunewflag = 1
						}
						if (data.CusGrade == 2) {
							this.tbyunewflag = 2
						}
						this.warehouseList(data)
					}
					if (this.typetb == 3) {
						this.$refs.tbadd[4].modelvalue = data.CusName
						this.$refs.tbadd[5].modelvalue = data.CusCode
						this.$refs.tbadd[6].modelvalue = data.CusGradeName
						//  this.cusCode =  data.CusName
						if (data.CusGrade == 1) {
							this.tbyuflag = 1
						}
						if (data.CusGrade == 2) {
							this.tbyuflag = 2
						}
						this.warehouseList(data)
					}
					if (this.typetb == 4) {
						this.$refs.tbadd[0].modelvalue = data.CusName
						this.$refs.tbadd[1].modelvalue = data.CusCode
						this.$refs.tbadd[2].modelvalue = data.CusGradeName
						this.cusCode = data.CusCode
						if (data.CusGrade == 1) {
							this.tbyuflag = 1
						}
						if (data.CusGrade == 2) {
							this.tbyuflag = 2
						}
						this.warehouseList(data)
					}
					if (this.typetb == 5) {
						this.$refs.tbupdate[0].modelvalue = data.CusName
						this.$refs.tbupdate[1].modelvalue = data.CusCode
						this.$refs.tbupdate[2].modelvalue = data.CusGradeName
						if (data.CusGrade == 1) {
							this.tbyuflag = 1
						}
						if (data.CusGrade == 2) {
							this.tbyuflag = 2
						}
						this.warehouseList(data)
					}
					if (this.typetb == 6) {
						this.$refs.tbupdate[5].modelvalue = data.CusCode
						this.$refs.tbupdate[6].modelvalue = data.CusGradeName
						if (data.CusGrade == 1) {
							this.tbyuflag = 1
						}
						if (data.CusGrade == 2) {
							this.tbyuflag = 2
						}
						this.warehouseList(data)
					}
				} else if (code == 999) {
					if (this.typetb == 1) {
						this.tbfromdata[3].options = []
						this.$refs.tbyuref[0].modelvalue = ""
						this.$message({
							type: "warning",
							message: message
						})
					}
					if (this.typetb == 2) {
						this.tbnewfromdata[3].options = []
						this.$refs.tbnewref[0].modelvalue = ""
						this.$message({
							type: "warning",
							message: message
						})
					}
					if (this.typetb == 3) {
						this.tbadd[7].options = []
						this.$refs.tbadd[4].modelvalue = ""

						this.$message({
							type: "warning",
							message: message
						})
					}
					if (this.typetb == 4) {
						this.addtb[3].options = []
						this.$refs.tbadd[0].modelvalue = ""

						this.$message({
							type: "warning",
							message: message
						})
					}
					if (this.typetb == 5) {
						this.updatetb[3].options = []
						this.$refs.tbupdate[0].modelvalue = ""
						this.$message({
							type: "warning",
							message: message
						})
					}
					if (this.typetb == 6) {

						this.updatetb[7].options = []
						this.$refs.tbupdate[4].modelvalue = ""
						this.$message({
							type: "warning",
							message: message
						})
					}

				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.topFromdata[0].options = []
					this.addtb[8].options = []
					this.updatetb[8].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.topFromdata[0].options.push(obj)
						this.addtb[8].options.push(obj)
						this.updatetb[8].options.push(obj)
					})

				}
			},
			// 导入
			async TransVouchImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await TransVouchImport(formdata)
				//console.log(code, message);
				if (code == 0) {
					this.$message({
						type: 'success',
						message: "导入成功"
					});
					this.dialogVisiblesqsjg = false
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.title = "导入结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
				this.$parent.transVouchList()
			},
			// 下载调拨唯一码明细
			async Uniqdowload() {
				let {
					data,
					code,
					message
				} = await TransVouchDownloadUniqueTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载调拨单模板
			async dowload() {
				let {
					data,
					code,
					message
				} = await TransVouchDownloadDetailTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载模板
			async dowloadTemplet() {
				console.log("下载");
				let {
					data,
					code,
					message
				} = await TransVouchDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},

			// 整仓调拨
			async transVouchChangeCustomerByTV() {
				let {
					code,
					data,
					message
				} = await TransVouchChangeCustomerByTV({
					InvClass: this.$refs.tbtopref[0].modelvalue,
					oOrganization: this.tbyuflag == 1 ? this.$refs.tbyuref[1].modelvalue : "",
					iOrganization: this.tbyunewflag == 1 ? this.$refs.tbnewref[1].modelvalue : "",
					oCusCode: this.tbyuflag == 2 ? this.$refs.tbyuref[1].modelvalue : "",
					iCusCode: this.tbyunewflag == 2 ? this.$refs.tbnewref[1].modelvalue : "",
					Remark: this.$refs.tbtopref[1].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.$refs.tbtopref[0].modelvalue = ""
					this.$refs.tbyuref.map((item, index) => {
						item.modelvalue = ""
					})
					this.$refs.tbnewref.map((item, index) => {
						item.modelvalue = ""
					})
					this.dialogVisiblestb = false
				} else {
					this.$message({
						type: "error ",
						message: message
					})
				}
				this.$parent.transVouchList()
			},
			invClass(e) {
				this.inventoryClassInfo(e.modelvalue)
			},
			// 判断是否开启唯一码
			async inventoryClassInfo(invClass) {
				let {
					code,
					data
				} = await InventoryClassInfo({
					invClass: invClass
				})
				if (code == 0) {
					if (data.IsBarCodeControl == 1) {
						let arr = [{
								title: '明细'
							},
							{
								title: '唯一码'
							}
						]
						this.$refs.AddDialog.wtypestate = false
						this.Uniqueflag = true
						this.Detailflag = false
						this.state = arr

					} else if (data.IsBarCodeControl == 0) {
						let arr = [{
							title: '明细'
						}]
						this.$refs.AddDialog.wtypes = 1
						this.$refs.AddDialog.onchage = 0
						this.$refs.AddDialog.wtypestate = true
						this.Uniqueflag = false
						this.Detailflag = true
						// this.wtype = 0
						this.state = arr
					}
				}
			},
			// 上传出库明细
			async UnImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await TransVouchImportDetail(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					let arr = []
					let objDet = {}
					data.DetailList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						objDet = Object.assign({}, item, {
							ids: num
						})
						arr.push(objDet)
					})
					this.$refs.AddDialog.tableDataDetailunNo = arr
					this.$refs.AddDialog.tableDataDetail = arr
					loading.close();
					return
				} else if (code === 1 && data.ErrMessage.length) {
					loading.close();
					this.$alert(`${data.ErrMessage.join('<br/>')}`, '提示', {
						dangerouslyUseHTMLString: true,
						showConfirmButton: false
					});
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 上传出库唯一码明细
			async UniqImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await TransVouchImportUnique(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					let arr = []
					let objDet = {}
					data.DetailList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						objDet = Object.assign({}, item, {
							ids: num
						})
						arr.push(objDet)
					})
					let arrUin = []
					let objUin = {}
					data.UniqueList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						objUin = Object.assign({}, item, {
							ids: num
						})
						arrUin.push(objUin)
					})
					this.$refs.AddDialog.tableDataDetailunNo = arr
					this.$refs.AddDialog.tableDataDetail = arr
					this.$refs.AddDialog.tableDataDetailUnique = arrUin
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			addckd() {
				this.inventoryClassList()
				this.cusCodeStatus = 'addckd'
				this.dialogVisibleoutboundorder = true
			},
			updateckd() {
				if (this.tvmidarr && this.tvmidarr.length === 1 && this.editops === false) {
					this.tvmid = this.tvmidarr[0].TVMID
					this.rowboo = true
					this.TransVouchInfo()
					this.inventoryClassList()
					this.dialogVisibleoutboundorderedit = true
					this.dialogindex = "update"
					this.cusCodeStatus = 'addckd'
					this.$emit('updateckd')
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要操作的数据！'
				});

			},
			canceloutboundorderedit() {
				this.dialogVisibleoutboundorderedit = false
			},
			dialogOKcanceloutboundorderedit() {

				this.dialogVisibleoutboundorderedit = false
			},
			async TransVouchAddOne() {
				let {
					code,
					message
				} = await TransVouchAdd({
					//    WHNames: "", WHCodes: "",
					OCusName: this.$refs.tbadd[0].modelvalue,
					OCusCode: this.$refs.tbadd[1].modelvalue,
					OCusType: this.$refs.tbadd[2].modelvalue,
					OWhCode: this.$refs.tbadd[3].modelvalue == this.WHNames ? this.WHCodes : this.$refs.tbadd[
						3].modelvalue,
					ICusName: this.$refs.tbadd[4].modelvalue,
					ICusCode: this.$refs.tbadd[5].modelvalue,
					ICusType: this.$refs.tbadd[6].modelvalue,
					IWhCode: this.$refs.tbadd[7].modelvalue == this.WHName7 ? this.WHCode7 : this.$refs.tbadd[
						7].modelvalue,
					InvClass: this.$refs.tbadd[8].modelvalue,
					remark: this.$refs.tbadd[10].modelvalue, //备注
					TransVouchReason: this.$refs.tbadd[9].modelvalue, //原因
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: this.$refs.AddDialog.tableDataDetailUnique, //出库唯一码明细（产品线开通唯一码时传）
				})
				if (code == 0) {
					this.dialogVisibleoutboundorder = false;
					this.$message({
						type: 'success',
						message: '保存成功'
					});
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else if (code == 999) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			async TransVouchAddTow(val) {
				let {
					code,
					message
				} = await TransVouchAdd({
					OCusName: this.$refs.tbadd[0].modelvalue,
					OCusCode: this.$refs.tbadd[1].modelvalue,
					OCusType: this.$refs.tbadd[2].modelvalue,
					OWhCode: this.$refs.tbadd[3].modelvalue == this.WHNames ? this.WHCodes : this.$refs.tbadd[
						3].modelvalue,
					ICusName: this.$refs.tbadd[4].modelvalue,
					ICusCode: this.$refs.tbadd[5].modelvalue,
					ICusType: this.$refs.tbadd[6].modelvalue,
					IWhCode: this.$refs.tbadd[7].modelvalue == this.WHName7 ? this.WHCode7 : this.$refs.tbadd[
						7].modelvalue,
					InvClass: this.$refs.tbadd[8].modelvalue,
					remark: this.$refs.tbadd[10].modelvalue, //备注
					TransVouchReason: this.$refs.tbadd[9].modelvalue, //原因
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: null, //出库唯一码明细（产品线开通唯一码时传）
				})
				if (code == 0) {
					this.dialogVisibleoutboundorder = false;
					this.$message({
						type: 'success',
						message: '保存成功'
					});
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			async TransEditOne(val) {
				let {
					code,
					message
				} = await TransVouchEdit({
					tvmid: this.tvmid,
					OCusName: this.$refs.tbupdate[0].modelvalue,
					OCusCode: this.$refs.tbupdate[1].modelvalue,
					OCusType: this.$refs.tbupdate[2].modelvalue,
					OWhCode: this.$refs.tbupdate[3].modelvalue,
					ICusName: this.$refs.tbupdate[4].modelvalue,
					ICusCode: this.$refs.tbupdate[5].modelvalue,
					ICusType: this.$refs.tbupdate[6].modelvalue,
					IWhCode: this.$refs.tbupdate[7].modelvalue,
					InvClass: this.$refs.tbupdate[8].modelvalue,
					remark: this.$refs.tbupdate[10].modelvalue, //备注
					TransVouchReason: this.$refs.tbupdate[9].modelvalue, //原因
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: this.$refs.AddDialog.tableDataDetailUnique, //出库唯一码明细（产品线开通唯一码时传）
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.dialogVisibleoutboundorderedit = false
					this.$parent.transVouchList()
					this.$refs.ChallengingRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 修改保存
			async TransVouchEdit() {
				let {
					code,
					message
				} = await TransVouchEdit({
					tvmid: this.tvmid,
					OCusName: this.$refs.tbupdate[0].modelvalue,
					OCusCode: this.$refs.tbupdate[1].modelvalue,
					OCusType: this.$refs.tbupdate[2].modelvalue,
					OWhCode: this.$refs.tbupdate[3].modelvalue,
					ICusName: this.$refs.tbupdate[4].modelvalue,
					ICusCode: this.$refs.tbupdate[5].modelvalue,
					ICusType: this.$refs.tbupdate[6].modelvalue,
					IWhCode: this.$refs.tbupdate[7].modelvalue,
					InvClass: this.$refs.tbupdate[8].modelvalue,
					remark: this.$refs.tbupdate[10].modelvalue, //备注
					TransVouchReason: this.$refs.tbupdate[9].modelvalue, //原因
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: null, //出库唯一码明细（产品线开通唯一码时传）
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.dialogVisibleoutboundorderedit = false
					this.$parent.transVouchList()
					this.$refs.ChallengingRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 添加保存
			addsave() {
				if (this.state.length == 2) {
					this.TransVouchAddOne()
				} else if (this.state.length == 1) {
					this.TransVouchAddTow()
				}
			},
			// 修改保存
			editsave() {
				if (this.state.length == 2) {
					this.TransEditOne()
				} else if (this.state.length == 1) {
					this.TransVouchEdit()
				}
			},
			BaChage(e) {
				// //console.log("kakak", e.modelvalue);
				this.typetb = 1
				this.baOrganizationInfo(e.modelvalue)
			},
			BanewChage(e) {
				this.typetb = 2
				this.baOrganizationInfo(e.modelvalue)
			},
			TBnewChage(e) {
				this.typetb = 4
				this.baOrganizationInfo(e)
			},
			TBChage(e) {
				this.typetb = 3
				this.baOrganizationInfo(e)
			},
			TBnewChageUp(e) {
				this.typetb = 5
				this.baOrganizationInfo(e)
			},
			TBChageUp(e) {
				this.typetb = 6
				this.baOrganizationInfo(e)
			},
			handleSelectionChange(val) {
				this.tvmidarr = val
				if (val.length === 1) {
					this.rowboo = true
					this.tvmid = val[0].TVMID
					this.editops = val[0].Status == 0 ? false : true
					return
				}
				this.rowboo = false
				this.editops = true
				if (val.length === 0) {
					this.tvmid = ""
				}
			},
			cancelqsjg() {
				this.dialogVisiblesqsjg = false
			},
			dialogOKqsjg() {
				this.dialogVisiblesqsjg = false
			},
			del() {
				if (this.tvmidarr.length > 0) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});

			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.transVouchDelete()
				this.dialogVisibledel = false
			},
			addclick() {

			},
			shen() {
				if (!this.tvmidarr.length) {
					this.$message({
						type: 'error',
						message: '请选择要审核的数据！'
					});
					return
				}
				this.dialogVisibleshen = true
			},
			dialogOKshen() {
				this.transVouchVerify()
				this.dialogVisibleshen = false
			},
			cancelshen() {
				this.dialogVisibleshen = false
			},
			qshen() {
				if (this.tvmidarr.length > 0) {
					this.dialogVisibleqshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要弃审的数据！'
				});

			},
			dialogOKqshen() {
				this.transVouchUnVerify()
				this.dialogVisibleqshen = false
			},
			cancelqshen() {
				this.dialogVisibleqshen = false
			},
			tb() {
				this.inventoryClassList()
				this.dialogVisiblestb = true
			},
			canceltb() {
				this.dialogVisiblestb = false
			},
			dialogOKtb() {
				this.transVouchChangeCustomerByTV()

			},
			handleChange() {

			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			canceloutboundorder() {
				this.$parent.transVouchList()
				this.dialogVisibleoutboundorder = false
			},
			dialogOKcanceloutboundorder() {
				this.$parent.transVouchList()
				this.dialogVisibleoutboundorder = false
			},
			showclick() {
				this.showorhide = true
			},
			hide() {
				this.showorhide = false

			},
			select() {

			},
			reset() {

			},
			tabClick(index) {
				if (index == 0) {
					this.Detailflag = true
					this.Uniqueflag = false
				} else {
					this.Uniqueflag = true
					this.Detailflag = false
				}
			},
			handleSelectionChangeAddDialogFromTable(val) {
				this.AddTableSelectiondetailList = val
			},
		},
		watch: {
			dialogVisibleoutboundorder: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.$refs.tbadd.map((item, index) => {
							item.modelvalue = ''
						})
						this.$refs.AddDialog.tableDataDetail.length = 0
						this.$refs.AddDialog.tableDataDetailunNo.length = 0
						this.$refs.AddDialog.tableDataDetailUnique.length = 0
					}
				},
				deep: true
			},
			dialogVisibleoutboundorderedit: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.$refs.ChallengingRef.$refs.fileTableSelect.clearSelection()
						this.rowboo = false
						this.$refs.AddDialog.tableDataDetail.length = 0
						this.$refs.AddDialog.tableDataDetailunNo.length = 0
						this.$refs.AddDialog.tableDataDetailUnique.length = 0
						// this.$parent.transVouchList()
					}
				}
			},
			dialogVisiblestb: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.$refs.tbtopref.map((item, index) => {
							item.modelvalue = ""
						})
						this.$refs.tbyuref.map((item, index) => {
							item.modelvalue = ""
						})
						this.$refs.tbnewref.map((item, index) => {
							item.modelvalue = ""
						})
					}
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {

		// height: 100%;
		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		div {
			margin-left: 8px;
			margin-right: 8px;
			margin-top: 5px;
			margin-bottom: 5px;
		}
	}

	.from {
		height: 555px;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.titlefrom {
		width: 120px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		border-left: 3px solid #e71d43;
		font-size: 14px;
		font-weight: bold;
	}
</style>